import { Reducer } from 'redux';
import _ from 'lodash';
import { IReduxAction } from 'app/types/actions';
import { PaymentEventsActionTypes as types, IPaymentEventsState } from './types';

const initialState: IPaymentEventsState = {
  paymentEventsById: {},
  paymentEventIds: [],
  currentPaymentEventId: undefined,
  isLoading: false,
  isSaving: false,
  hasLoaded: false,
  hasSaved: false,
  hasFailed: false,
  requestedData: {},
  backendErrors: {},
  showAddPaymentEvent: false,
  filterConfig: {},
  sortConfig: {},
  pagination: {
    page: {
      size: 200,
      number: 0,
    },
    filter: [],
    sort: [],
    meta: {
      totalCount: undefined,
      totalPages: undefined,
    },
  },
};

const reducer: Reducer<IPaymentEventsState> = (
  state = initialState,
  action: IReduxAction,
) => {
  switch (action.type) {
    case types.GET_ALL_PAYMENT_EVENTS_PENDING: {
      return {
        ...state,
        isLoading: true,
        hasLoaded: false,
        pagination: {
          ...state.pagination,
          ...action.payload.pagination,
        },
      };
    }
    case types.GET_ALL_PAYMENT_EVENTS_SUCCESS: {
      let { paymentEventsById } = action.payload;
      let { paymentEventIds } = action.payload;
      if (action.payload.append) {
        paymentEventsById = { ...state.paymentEventsById, ...action.payload.paymentEventsById };
        paymentEventIds = _.concat([], state.paymentEventIds, action.payload.paymentEventIds);
      }

      return {
        ...state,
        paymentEventsById,
        paymentEventIds,
        isLoading: false,
        hasLoaded: true,
        pagination: {
          ...state.pagination,
          meta: action.payload.meta,
        },
      };
    }
    case types.GET_ALL_PAYMENT_EVENTS_FAIL: {
      return {
        ...state,
        isLoading: false,
        hasLoaded: false,
        backendErrors: action.payload.backendErrors,
      };
    }
    case types.GET_PAYMENT_EVENT_PENDING: {
      return {
        ...state,
        isLoading: true,
        hasLoaded: false,
      };
    }
    case types.GET_PAYMENT_EVENT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        hasLoaded: true,
        paymentEventsById: _.merge(
          {},
          state.paymentEventsById,
          action.payload.paymentEventsById,
        ),
        paymentEventIds: _.union(state.paymentEventIds, [
          action.payload.currentPaymentEventId,
        ]),
        currentPaymentEventId: action.payload.currentPaymentEventId,
      };
    }
    case types.GET_PAYMENT_EVENT_FAIL: {
      return {
        ...state,
        isLoading: false,
        hasLoaded: false,
        backendErrors: action.payload.backendErrors,
      };
    }
    case types.SELECT_PAYMENT_EVENT_REQUESTED: {
      return {
        ...state,
        currentPaymentEventId: action.payload.currentPaymentEventId,
      };
    }
    case types.UPDATE_PAYMENT_EVENT_PENDING: {
      return {
        ...state,
        isSaving: true,
        hasSaved: false,
        hasFailed: false,
        requestedData: action.payload,
        backendErrors: {},
      };
    }
    case types.UPDATE_PAYMENT_EVENT_SUCCESS: {
      return {
        ...state,
        isSaving: false,
        hasSaved: true,
        hasFailed: false,
        paymentEventsById: _.merge(
          {},
          state.paymentEventsById,
          action.payload.paymentEventsById,
        ),
        paymentEventIds: _.union(state.paymentEventIds, [
          action.payload.currentPaymentEventId,
        ]),
        currentPaymentEventId: action.payload.currentPaymentEventId,
      };
    }
    case types.UPDATE_PAYMENT_EVENT_FAIL: {
      return {
        ...state,
        isSaving: false,
        hasFailed: true,
        hasSaved: false,
        backendErrors: action.payload.backendErrors,
      };
    }
    case types.CREATE_PAYMENT_EVENT_PENDING: {
      return {
        ...state,
        isSaving: true,
        hasSaved: false,
        hasFailed: false,
        requestedData: action.payload,
        backendErrors: {},
      };
    }
    case types.CREATE_PAYMENT_EVENT_SUCCESS: {
      return {
        ...state,
        isSaving: false,
        hasSaved: true,
        hasFailed: false,
        paymentEventsById: _.merge(
          {},
          state.paymentEventsById,
          action.payload.paymentEventsById,
        ),
        paymentEventIds: _.union(state.paymentEventIds, [
          action.payload.currentPaymentEventId,
        ]),
        currentPaymentEventId: action.payload.currentPaymentEventId,
      };
    }
    case types.CREATE_PAYMENT_EVENT_FAIL: {
      return {
        ...state,
        isSaving: false,
        hasFailed: true,
        hasSaved: false,
        backendErrors: action.payload.backendErrors,
      };
    }
    case types.DELETE_PAYMENT_EVENT_PENDING: {
      return {
        ...state,
        isSaving: true,
        hasSaved: false,
        hasFailed: false,
      };
    }
    case types.DELETE_PAYMENT_EVENT_SUCCESS: {
      return {
        ...state,
        isSaving: false,
        hasSaved: true,
        hasFailed: false,
        paymentEventsById: _.omit(
          state.paymentEventsById,
          action.payload.currentPaymentEventId,
        ),
        paymentEventIds: _.without(
          state.paymentEventIds,
          action.payload.currentPaymentEventId,
        ),
        currentPaymentEventId: undefined,
      };
    }
    case types.DELETE_PAYMENT_EVENT_FAIL: {
      return {
        ...state,
        isSaving: false,
        hasFailed: true,
        hasSaved: false,
        backendErrors: action.payload.backendErrors,
      };
    }
    default:
      return state;
  }
};

export default reducer;
